import * as React from 'react';
type Props = {
  className?: string;
};
export function CaretRight({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-caret-right"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.563 12.6835L8.33203 20L7.11683 18.6329L14.5788 12L7.11683 5.3671L8.33203 4L16.563 11.3165C16.7583 11.49 16.87 11.7388 16.87 12C16.87 12.2612 16.7583 12.51 16.563 12.6835Z"
        fill="currentColor"
      />
    </svg>
  );
}
